module.exports = __webpack_public_path__ + "static/media/piano-a.f5f7a912.wav";